<app-loader *ngIf="isDisabled"></app-loader>
<div class="single-row-container">
    <div class="header-row">
        <div class="row w-100 gap-2">
            <div class="col align-content-center">
                <i class="bi bi-stopwatch"></i>
                <span class="fw-bold ps-2">Site Type Master</span>
            </div>
            <div class="col-auto p-0">
                <button type="button" class="upload-btn" id="exportBtn" *ngIf="this.common.PageRight.IsPrint"
                    (click)="excelDownload()" [disabled]="isDisabled">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Export':'Loading...'}}
                </button>
            </div>
            <!-- <div class="col-auto p-0">
                <button *ngIf="this.common.PageRight.IsAdd" type="button" (click)="upload()" class="upload-btn"
                    [disabled]="isDisabled">
                    <i class="bi bi-upload" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Upload':'Loading...'}}
                </button>
            </div> -->
            <div class="col-auto p-0">
                <button type="button" class="upload-btn" id="addBtn" (click)="add(0)" [disabled]="isDisabled"
                    *ngIf="this.common.PageRight.IsAdd">
                    <i class="bi bi-plus" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Add Site Type':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
    <div class="m-3">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Action</th>
                    <th>Site Type Name</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of TableData">
                    <td style="width: 5px;">
                        <div class="text-center" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                            <button class="btn btn-sm btn-warning" type="button"
                                (click)="add(element['SiteTypeMasterID'])"><i
                                    class="bi bi-pencil-square"></i></button>
                        </div>
                    </td>
                    <td> {{element['SiteTypeName']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- <div>
    <div class="row pb-2">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" (click)="add(0)"
                [disabled]="isDisabled">
                <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Site Type':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Site Type Master
        </div>
        <div class="card-body p-1">

        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">

                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">

                    <button (click)="excelDownload()" class="btn btn-primary btn-sm">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}</button>

                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="exportToExcel()">
                        <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                    &nbsp;
                    <button *ngIf="this.common.PageRight.IsPrint" class="btn btn-sm btn-primary" name="sample"
                        (click)="downloadExcel()">
                        <i class="bi bi-file-earmark-excel" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Sample':'Loading...'}}
                    </button>
                    &nbsp;
                    <label *ngIf="this.common.PageRight.IsPrint" for="file-upload" class="btn btn-sm btn-primary">
                        <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
                    </label>
                    <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                        accept=".xls,.xlsx">
                </div>
            </div>
        </div>
    </div>
</div> -->